import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  {
    name: 'quote',
    meta: { title: 'Quote' },
    path: '/',
    component: require('./views/quote.vue').default
  },
  {
    name: 'affiliate',
    meta: { title: 'Affiliate' },
    props: true,
    path: '/affiliate/:agent/:category/:airportA/:product_id/:dateA/:timeA/:dateB/:timeB',
    component: require('./views/affiliate.vue').default
  },
  {
    name: 'airporthotel-results',
    meta: { title: 'Results' },
    path: '/airporthotel-results',
    component: require('./views/airport-hotel.vue').default
  },
  {
    name: 'airportparking-results',
    meta: { title: 'Results' },
    path: '/airportparking-results',
    component: require('./views/airport-parking.vue').default
  },
  {
    name: 'airportlounge-results',
    meta: { title: 'Results' },
    path: '/airportlounge-results',
    component: require('./views/airport-lounge.vue').default
  },
  {
    name: 'cross-sell',
    meta: { title: 'Upgrades' },
    path: '/upgrades',
    component: require('./views/cross-sell.vue').default
  },
  {
    name: 'payment',
    meta: { title: 'Payment' },
    path: '/payment',
    component: require('./views/payment.vue').default
  },
  {
    name: 'confirming',
    meta: { title: 'Confirming' },
    path: '/confirming',
    component: require('./views/confirming.vue').default
  },
  {
    name: 'confirmation',
    meta: { title: 'Confirmation' },
    path: '/confirmation',
    component: require('./views/confirmation.vue').default
  },
  {
    name: 'confirmation-view',
    meta: { title: 'View confirmation' },
    path: '/confirmation-view',
    component: require('./views/confirmation-view.vue').default
  },
  { path: '*', redirect: '/airportparking-results' }
];

const router = new VueRouter({
  mode: 'history',
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  base: '/booking-quote',
  routes
});

// This callback runs before every route change, including on page load.
router.beforeEach((to, from, next) => {

  // This goes through the matched routes from last to first, finding the closest route with a title.
  // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);

  // Find the nearest route element with meta tags.
  const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

  // If a route with a title was found, set the document (page) title to that value.
  if (nearestWithTitle) document.title = nearestWithTitle.meta.title;

  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el));

  // Skip rendering meta tags if there are none.
  if (!nearestWithMeta) return next();

  // Turn the meta tag definitions into actual elements in the head.
  nearestWithMeta.meta.metaTags.map(tagDef => {
    const tag = document.createElement('meta');

    Object.keys(tagDef).forEach(key => {
      tag.setAttribute(key, tagDef[key]);
    });

    // We use this to track which meta tags we create, so we don't interfere with other ones.
    tag.setAttribute('data-vue-router-controlled', '');

    return tag;
  })
    // Add the meta tags to the document head.
    .forEach(tag => document.head.appendChild(tag));

  next();
});

export default router;